@if(file && show){
<div class="preview-background">
     <div class="header flex center justify-between">
          <div class="flex-1"></div>
          @if(file.FileName){
          <div class="flex-1 flex center justify-center uppercase">
               {{file.FileName}}
          </div>
          }
          <div class="flex-1 flex center justify-end actions">
               <i class="fa fa-download hover" (click)="onDownload()"></i>
               <i class="fa fa-times hover" (click)="onClose()"></i>
          </div>
     </div>
     <div class="main-container" (mousewheel)="onZoom($event)">
          <img [id]="imgId" [src]="file.FilePath" [style.height.px]="imgH" [style.width.px]="imgW">

          @if(zoomPerc){
          <div @opacityAnimation class="perc">{{zoomPerc}}% ({{imgW}}x{{imgH}} px)</div>
          }
     </div>
</div>
}